import UniversitiesPage from './UniversitiesPage';

export default function StudyEuropePage() {
  return (
    <div>
      <div className="bg-primary text-primary-foreground py-12">
        <div className="container mx-auto px-4 md:px-8 lg:px-12">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold mb-4">Study in Europe</h1>
          <p className="text-lg text-primary-foreground/90 max-w-3xl">
            Europe offers world-class education with rich cultural heritage, affordable tuition, and internationally recognized degrees. Discover prestigious European universities with centuries of academic excellence.
          </p>
        </div>
      </div>
      <UniversitiesPage country="UK" />
    </div>
  );
}